import {Component, OnInit} from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit {
    public menuItems: any[];
    isFolded: boolean;
    isSideNavDark: boolean;
    url: string = 'link_route';
    selectedIndex : any = null;
    constructor( 
        private themeService: ThemeConstantService,
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.url = this.route.snapshot['_routerState'].url;
        this.router.events.subscribe( (event) => {
            if (event instanceof NavigationEnd) {
               this.url = event.url || '';
               this.checkUrl(this.url);
            }
        });
        this.checkUrl(this.route.snapshot['_routerState'].url);
    }
    checkUrl(url) {
        const split = (url || '').split('/');
        if (!split[0]) {
            split.shift();
        }
        const routes: any = {};
        split.forEach((route) => routes[route] = true);
        this.menuItems.forEach((menu) => {
            menu.selected = menu.path === '/' + split[0] || menu.path === split[0]; 
        })
    }
    checkActive(event, index) {
        this.selectedIndex = index;
        const item = this.menuItems[index];
        return item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'
    }
    test(index) {
        this.selectedIndex = this.selectedIndex !== index ? index : null;
    }
}
